import { Badge, Box, Button, Flex, HStack, IconButton, SimpleGrid } from '@chakra-ui/react';
import TableComponent from 'components/TableComponent';
import { DateTime } from 'luxon';
import { FC, useMemo } from 'react';
import { FaEye, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Column } from 'react-table';
import { findWithdrawalBatches, WithdrawalBatch, WithdrawalBatchStatus } from 'services/api.service';
import { maskCurrency } from 'utils/number';

export const WithdrawalBatchStatusRender: FC<{ status: WithdrawalBatchStatus }> = ({ status }) => {
  const map: Record<WithdrawalBatchStatus, [string, string]> = {
    PENDING: ['orange', 'Rascunho'],
    PENDING_APPROVAL: ['purple', 'Aguardando aprovação'],
    PROCESSING: ['blue', 'Processando'],
    COMPLETED: ['green', 'Concluído'],
    PARTIALLY_COMPLETED: ['yellow', 'Parcial'],
    FAILED: ['red', 'Falhou'],
    CANCELED: ['gray', 'Cancelado'],
  };
  const [scheme, label] = map[status] ?? ['gray', status];
  return <Badge colorScheme={scheme}>{label}</Badge>;
};

export default function WithdrawalsBatch() {
  const navigate = useNavigate();
  const columns = useMemo(
    () =>
      [
        { Header: 'Criado em', accessor: 'createdAt', Cell: ({ value }: any) => DateTime.fromISO(value).toFormat('dd/MM/yyyy HH:mm') },
        { Header: 'Status', accessor: 'status', Cell: ({ value }: any) => <WithdrawalBatchStatusRender status={value} /> },
        { Header: 'Itens', accessor: 'totalItems' },
        { Header: 'Total', accessor: 'totalAmount', Cell: ({ value }: any) => maskCurrency(+value) },
        { Header: 'Sucesso', accessor: 'succeededItems' },
        { Header: 'Falhas', accessor: 'failedItems' },
        { Header: 'Ações', accessor: 'actions' },
      ] as Column[],
    [],
  );

  const actions = (row: WithdrawalBatch) => (
    <Flex>
      <IconButton aria-label="Ver" size="sm" variant="outline" icon={<FaEye />} onClick={() => navigate(`/access/withdrawals-batch/${row.id}`)} />
    </Flex>
  );

  return (
    <Box>
      <HStack justify="flex-end" mb={4}>
        <Button leftIcon={<FaPlus />} colorScheme="brand" onClick={() => navigate('/access/withdrawals-batch/new')}>
          Novo lote
        </Button>
      </HStack>
      <SimpleGrid columns={{ sm: 1 }} spacing="20px">
        <TableComponent label="Saques em Lote" columnsData={columns} queryFn={findWithdrawalBatches} queryKey="findWithdrawalBatches" actions={actions} />
      </SimpleGrid>
    </Box>
  );
}
